<template>
  <div>
    <div class="content-title">基本信息</div>
    <div class="content-tool">
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="户名："><span>{{ basicinfo.providerName }}</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="账号："><span>{{ basicinfo.bankAccount }}</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="开户行："><span>{{ basicinfo.bankAccountName }}</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="电话："><span>{{ basicinfo.phone }}</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="纳税人识别号："><span>{{ basicinfo.taxpayerIDNumber }}</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="联系地址："><span>{{ basicinfo.address }}</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="联系人："><span>{{ basicinfo.contactUser }}</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="平台名称："><span>{{ basicinfo.platformName }}</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="登录账号："><span>{{ basicinfo.loginAccount }}</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="服务费率："><span>{{ basicinfo.serviceRate / 100 + '%' }}</span>
        <span style="font-size: 13px; margin-left: 10px;">《 总结算额=实发金额 * (1 + {{ basicinfo.serviceRate / 100 + '%' }} ) 》</span></el-form-item>
      </el-form>
      <el-form :model="basicinfo" label-width="120px">
        <el-form-item label="服务商："><span>{{ basicinfo.serviceName }}</span></el-form-item>
        <!-- <el-form-item label="服务商："><span>迅启启丰</span></el-form-item> -->
      </el-form>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
// import { Loading } from 'element-ui';
// import { parseTime } from '@/utils';

export default {
  name: 'basicinfo',
  data() {
    return {
      basicinfo: {},
      accountId: null,
    };
  },
  mounted() {
    this.accountId = this.$route.query.accountId;
    this.fetchBasicInfo(this.accountId);
  },
  methods: {
    fetchBasicInfo(accountId) {
      api.fetchBasicInfo({
        params: {
          params: {
            accountId,
          },
        },
      }).then((res) => {
        this.basicinfo = res;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.content-tool {
  // padding: 27px 17px 20px 17px;
  // border: 1px solid #ebeef5;
  background: #fff;
  font-size: 15px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
    padding: 0px 17px 20px 17px;
    margin: 0px 20px 20px 20px;
  }
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>

<style scoped>
.el-form .el-form-item{
  margin-bottom: 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/basicinfo.vue